import { ErrorResponse} from '@gtpl/shared-models/common-models';
import { AllvalueAdditionOneResponse, CommonResponse, Type1Dto, ValueAdditionIdModel, valueAdditionIdResponse, ValueAdditionOneDto, valueAdditionOneResponse } from '@gtpl/shared-models/masters';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { LogActions } from 'apps/services/logger/logger-functions';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { Raw, Repository } from 'typeorm';
import { UserRequestDto } from '../currencies/dto/user-logs-dto';
import { ValueAddOneTypeAdapter } from './dto/value-addition-one.adapter';
import { ValueAdditionOneDTO } from './dto/value-addition-one.dto';
import { ValueAdditionOneRequest } from './dto/value-addition.request';
import { ValueAdditionOneType } from './value-addition-one.entity';

@Injectable()
export class ValueAddition1TypesService {
    constructor(
      private logService:LogsService,
        @InjectRepository(ValueAdditionOneType) private foodTypeRepository: Repository<ValueAdditionOneType>,
        private valAddOneAdapter: ValueAddOneTypeAdapter,
      ) { }

      async createValAddOneType(valAddDto: ValueAdditionOneDTO, isUpdate: boolean,request:Request): Promise<valueAdditionOneResponse> {
        try {
        let previousValue;
        if (!isUpdate) {
            console.log(valAddDto)
            const valAddOneTypeEntity = await this.getDuplicateValAddOneType(valAddDto.code);
          if (valAddOneTypeEntity) {
            throw new valueAdditionOneResponse(false,11104, 'Value Addition Type already exists');
          }
        }
        else{
            const certificatePrevious = await this.foodTypeRepository.findOne({where:{valueAdditionOneId:valAddDto.valueAdditionOneId}})
            previousValue = certificatePrevious.name+" , "+certificatePrevious.code
            const valAddOneTypeEntity = await this.getDuplicateValAddOneType(valAddDto.code);
            if (valAddOneTypeEntity) {
                if(valAddOneTypeEntity.valueAdditionOneId!=valAddDto.valueAdditionOneId){
                    throw new valueAdditionOneResponse(false,11104, 'Value Addition Type already exists');
                }
            }
        }
        const convertedvalAddTypeEntity: ValueAdditionOneType = this.valAddOneAdapter.convertDtoToEntity(valAddDto,isUpdate);
        const savedValAddEntity: ValueAdditionOneType = await this.foodTypeRepository.save(convertedvalAddTypeEntity);
        const savedValAddTypeDto: ValueAdditionOneDTO = this.valAddOneAdapter.convertEntityToDto(savedValAddEntity);
       
         if (savedValAddTypeDto) {
            let present = savedValAddTypeDto.name +" , "+savedValAddTypeDto.code
          const response = new valueAdditionOneResponse(true,isUpdate ? 11100 : 11101,isUpdate? 'Value Addition Type One Updated Successfully':'Value Addition Type One Created Successfully',savedValAddTypeDto);
          const name=isUpdate?'updated':'created'
          const displayValue = isUpdate? 'Value Addition Type One Updated Successfully': 'Value Addition Type One Created Successfully'
            const userName = isUpdate? savedValAddTypeDto.updatedUser :savedValAddTypeDto.createdUser;
            const newLogDto = new LogsDto(1,name, 'ValueAdditionOneType', savedValAddTypeDto.valueAdditionOneId, true, displayValue,userName,previousValue,present)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
          return response;
        } else {
          throw new valueAdditionOneResponse(false,11106,'Value Addition Type saved but issue while transforming into DTO');
        }
      }
      catch (error) {
        return error;
      }
    }

         /**
     * gets all  val addition one types details  
     * @returns all the val addition one type details .
     */
    // @LogActions({ isAsync: true })
    async getAllValAddTypes(req?:UserRequestDto): Promise<AllvalueAdditionOneResponse> {  
        try {
            const valAddDto: ValueAdditionOneDto[] = [];
            // retrieves all plants
            const valAddOneTypeEntities: ValueAdditionOneType[] = await this.foodTypeRepository.find({
                order: { name: "ASC" },
            });
            //   console.log(valAddOneTypeEntities);
            if (valAddOneTypeEntities.length>0) {
                valAddOneTypeEntities.forEach(valAddOneTypeEntity => {
                const convertedValAddTypeDto: ValueAdditionOneDto = this.valAddOneAdapter.convertEntityToDto(valAddOneTypeEntity);
                valAddDto.push(convertedValAddTypeDto);
                });
                const response = new AllvalueAdditionOneResponse(true, 11208, "Value Addition Types retrieved successfully", valAddDto);
                if(req?.createdUser){
                    const newLogDto = new LogsDto(1,'view', 'ValueAdditionOneType', 0, true, 'Value Addition Types retrieved successfully',req.createdUser,'','')
                    let res = await this.logService.createLog(newLogDto);
                    console.log(res);
                }
                return response;
            } else {
                //   console.log('yest')
                throw new valueAdditionOneResponse(false,99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }

        /**
     * gets all  val addition one types details  
     * @returns all the val addition one type details .
     */
    // @LogActions({ isAsync: true })
    async getAllActiveValAddTypes(): Promise<AllvalueAdditionOneResponse> {  
        try {
            const valAddDto: ValueAdditionOneDto[] = [];
            // retrieves all plants
            const valAddOneTypeEntities: ValueAdditionOneType[] = await this.foodTypeRepository.find({where:{isActive:true},
                order: { name: "ASC" },
            });
            //   console.log(valAddOneTypeEntities);
            if (valAddOneTypeEntities.length>0) {
                valAddOneTypeEntities.forEach(valAddOneTypeEntity => {
                const convertedValAddTypeDto: ValueAdditionOneDto = this.valAddOneAdapter.convertEntityToDto(valAddOneTypeEntity);
                valAddDto.push(convertedValAddTypeDto);
                });
                const response = new AllvalueAdditionOneResponse(true, 11208, "Value Addition Types retrieved successfully", valAddDto);
                return response;
            } else {
                //   console.log('yest')
                throw new valueAdditionOneResponse(false,99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }


    async getValAddOneType(valueAdditionOneId:number): Promise<ValueAdditionOneType> {
        //  console.log(employeeId);
            const employeeResponse = await this.foodTypeRepository.findOne({
            where: {valueAdditionOneId: Raw(alias => `value_addition_one_id = '${valueAdditionOneId}'`)},
            });
            // console.log(employeeResponse);
            if (employeeResponse) {
            return employeeResponse;
            } else {
            return null;
            }
        }

        async getDuplicateValAddOneType(valueAdditionOneCode:string): Promise<ValueAdditionOneType> {
            //  console.log(employeeId);
                const employeeResponse = await this.foodTypeRepository.findOne({
                where: {valueAdditionOneId: Raw(alias => `code = '${valueAdditionOneCode}'`)},
                });
                // console.log(employeeResponse);
                if (employeeResponse) {
                return employeeResponse;
                } else {
                return null;
                }
            }

    /**
     * It deactivates value addition value  type 
     * @param foodTypeRequest addition  type  as string
     * @returns true or false
     */
    // @LogActions({isAsync: true})
    async activateOrDeactivateValAddOne(valAddOneReq: ValueAdditionOneRequest): Promise<valueAdditionOneResponse> {
        try {
            const FoodTypeExists = await this.getValAddTypeById(valAddOneReq.valueAdditionOneId);
            if (FoodTypeExists) {
                if (valAddOneReq.versionFlag !== FoodTypeExists.versionFlag) {
                    throw new valueAdditionOneResponse(false,10113, 'Someone updated the current Value Addition Type information.Refresh and try again');
                } else {
                    
                        const foodTypeSatatus =  await this.foodTypeRepository.update(
                            { valueAdditionOneId: valAddOneReq.valueAdditionOneId },
                            { isActive: valAddOneReq.isActive,updatedUser: valAddOneReq.updatedUser });
                       
                        if (FoodTypeExists.isActive) {
                            if (foodTypeSatatus.affected) {
                                const foodTypeResponse: valueAdditionOneResponse = new valueAdditionOneResponse(true, 10115, 'Value Addition Type is de-activated successfully');
                                return foodTypeResponse;
                            } else {
                                throw new valueAdditionOneResponse(false,10111, 'Value Addition Type is already deactivated');
                            }
                        } else {
                            if (foodTypeSatatus.affected) {
                                const foodTypeResponse: valueAdditionOneResponse = new valueAdditionOneResponse(true, 10114, 'Value addition type is activated successfully');
                                return foodTypeResponse;
                            } else {
                                throw new valueAdditionOneResponse(false,10112, 'Value addition type is already  activated');
                            }
                        }
                    // }
                }
            } else {
                throw new valueAdditionOneResponse(false,99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getValAddTypeById(valueAdditionId: number): Promise<ValueAdditionOneType> {
    //  console.log(employeeId);
        const Response = await this.foodTypeRepository.findOne({
        where: {valueAdditionOneId: valueAdditionId},
        });
        // console.log(employeeResponse);
        if (Response) {
        return Response;
        } else {
        return null;
        }
    }
    /**
     * Function to get valAddDetails
     * @param valueAdditionId  
     */
    async getValAddDetails(valueAdditionId: number): Promise<valueAdditionIdResponse> {
        const valAddData = await this.foodTypeRepository.findOne({select: ['name','code'], where: {valueAdditionOneId: valueAdditionId}});
        if(valAddData) {
            const modelResponse = new ValueAdditionIdModel(valAddData.name, valAddData.code);
            const response = new valueAdditionIdResponse(true, 11208, "Value Addition Types retrieved successfully", modelResponse);
            return response;
        } else {
            return null;
        }   
    }

    async createShortCodeAsVA1(req:Type1Dto):Promise<CommonResponse>{
        try{
            const findPrevData = await this.foodTypeRepository.find({where:{name:req.name}})
            if(findPrevData.length > 0){
                return new CommonResponse(true,100,'Data retrieved',findPrevData)
            }else{
                const entityObj = new ValueAdditionOneType()
                entityObj.code = req.code
                entityObj.name = req.name
                entityObj.createdUser = req.createdUser
                const save = await this.foodTypeRepository.save(entityObj)

                if(save){
                    return new CommonResponse(true,101,'Daved successfully',save)
                }else{
                    return new CommonResponse(false,0,'Something went wrong') 
                }
            }

        }catch(err){
            throw err
        }
    }
}
